import { useFetch } from '@/hooks/useFetch';
import type { GetPassportClientDataResponse } from '@/types/clientDetailsApiTypes';
import { useQuery } from '@tanstack/react-query';

export const CLIENT_PASSPORT_DATA_QUERY_KEY = 'client-passport-data';

export const useGetClientPassportData = (clientId: string | null, type: 'text_only' | 'image_only' = 'text_only') => {
  const { doFetch: getClientPassportData } = useFetch<void, GetPassportClientDataResponse>();

  return useQuery({
    queryKey: [CLIENT_PASSPORT_DATA_QUERY_KEY, clientId],
    queryFn: () => getClientPassportData(`/api/documents/passport/client/${clientId}?type=${type}`, { method: 'GET' }),
    enabled: !!clientId,
  });
};